import { iconList } from "../iconSVG"


const ModelCarousel = () => {

    
    const servicesTravel = [
        {
            title: "Vuelos",
            img: iconList.IconPlane,
            route: '/fligths'
        },
        {
            title: "Hoteles",
            img: iconList.IconHotel,
            route: '/hotel'
        },
        {
            title: "Tours",
            img: iconList.IconBag,
            route: '/tours'
        },
        {
            title: "Traslados",
            img: iconList.IconTaxi,
            route: '/transport'
        },
        {
            title: "Renta de Autos",
            img: iconList.IconRentaCar,
            route: '/carRentals'
        },
        {
            title: "Paquetes",
            img: iconList.IconTravel,
            route: '/packages'
        },
        {
            title: "Seguros de Viaje",
            img: iconList.IconSecureTravel,
            route: '/travelSecure'
        },
    ]


  return {
    servicesTravel

  }
}

export default ModelCarousel